function AiGlyph({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M19.2 2.4l.55 1.25 1.25.55-1.25.55-.55 1.25-.55-1.25-1.25-.55 1.25-.55.55-1.25z"
        fill="currentColor"
      />
      <path
        d="M12 7.25V5.4"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <circle cx="12" cy="4.35" r="1.05" fill="currentColor" />
      <rect
        x="5.4"
        y="7.4"
        width="13.2"
        height="11.4"
        rx="3.6"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <circle cx="9.55" cy="12.55" r="1.2" fill="currentColor" />
      <circle cx="14.45" cy="12.55" r="1.2" fill="currentColor" />
      <path
        d="M10.15 16.05c.55.7 1.15.7 1.7 0"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function AiMark({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full text-[color:var(--ai-on-accent)] ${className}`}
      style={{ backgroundColor: "var(--ai-accent)" }}
      aria-hidden
    >
      <AiGlyph className="h-[68%] w-[68%]" />
    </span>
  );
}

export { AiGlyph };
